import gql from 'graphql-tag';

export const PERMIT_CONTRACTOR_FRAGMENT = gql`
  fragment PermitContractorFragment on PermitContractorType {
    id
    businessName
    city
    email
    license
    name
    phone
    state
    street
    streetNo
    zipcode
    shovelsContractorId
    createdAt
    updatedAt
  }
`;

export const PERMIT_FRAGMENT = gql`
  ${PERMIT_CONTRACTOR_FRAGMENT}

  fragment PermitFragment on PermitType {
    id
    description
    fees
    fileDate
    finalDate
    issueDate
    jurisdiction
    number
    permitSubtype
    permitType
    source
    status
    permitContractorId
    shovelsContractorId
    shovelsPermitId
    createdAt
    updatedAt

    permitContractor {
      ...PermitContractorFragment
    }
  }
`;

export const PROPERTY_FRAGMENT = gql`
  ${PERMIT_FRAGMENT}

  fragment PropertyFragment on PropertyType {
    id
    address
    street
    street2
    city
    state
    zipCode
    country
    homeType
    totalSquareFeet
    bedrooms
    bathrooms
    yearBuilt
    photo {
      url
    }
    timezone
    permits {
      ...PermitFragment
    }
    latitude
    longitude
  }
`;

export const ORDER_STAKEHOLDER_FRAGMENT = gql`
  fragment OrderStakeholderFragment on OrderStakeholderType {
    id
    email
    name
    phone
    stakeholderType
    isClient
  }
`;

export const ORDER_FRAGMENT = gql`
  ${ORDER_STAKEHOLDER_FRAGMENT}
  ${PROPERTY_FRAGMENT}

  fragment OrderFragment on OrderType {
    id
    accessInformation
    inspectorInstructions
    team {
      automatedTroubleshootingInformation
      cannotAnswerNoAccessRequiresMedia
      useCustomDeficiencyBank
      useCustomLimitationBank
      allowPublishReportBeforeCompletion
    }
    accessInformations {
      id
      orderUnitId
      code
      contactName
      contactPhoneNumber
      contactEmail
      directions
      humanReadableSummary
      lockboxBrand
      mlsId
      mlsName
      type
    }
    orderUnits {
      id
      name
      createdAt
      updatedAt
      accessInformations {
        id
        orderUnitId
        type
        code
        contactName
        contactPhoneNumber
        contactEmail
        directions
        humanReadableSummary
        lockboxBrand
        mlsId
        mlsName
      }
    }
    contingencyDate
    earliestInspectionDate
    isMock
    isAppointmentBased
    createdAt
    inspectionSchedulingDeadline
    readOnlyToken
    isPaywall
    status
    teamId
    teamExternalId
    inspections {
      id
    }
    occupancyInfo
    orderStakeholders {
      ...OrderStakeholderFragment
    }
    propertyId
    property {
      ...PropertyFragment
    }
  }
`;

export const INSPECTION_PROPOSAL_FRAGMENT = gql`
  fragment InspectionProposalFragment on InspectionProposalType {
    id
    inspectionId
    contractorId
    availability
    totalFee
    contractorRepresentative
    durationHour
    contractorFee
    contractorPaidAt
    teamInternalUserTypeId
    isGoAnytime
    contractorPaymentPlatform
  }
`;

export const INSPECTION_FRAGMENT = gql`
  ${INSPECTION_PROPOSAL_FRAGMENT}

  fragment InspectionFragment on InspectionType {
    id
    inspectionType
    inspectionSubtype
    # contractorFee
    geotaggingRequired
    orderId
    scheduledProposalId
    inspectionScopeNumber
    scheduledProposal {
      ...InspectionProposalFragment
    }
    status
    templateReportId
    appRequirement
    createdAt
  }
`;

export const REPORT_RECORD_FRAGMENT = gql`
  fragment ReportRecordFragment on ReportType {
    id
    templateReportIds
    templateNames
    createdAt
    updatedAt
    startedAt
    publishedAt
    pdfDocumentUrl
    originalReportId
    noDeficienciesAllowed
    noLimitationsAllowed
    autoDeficiencyLocationRequired
    geotaggingRequired
    includePermitData
    includeWideAnglePhotos
    complianceText
    reportSystems {
      id
    }
  }
`;

export const JOB_FRAGMENT = gql`
  ${REPORT_RECORD_FRAGMENT}
  ${INSPECTION_FRAGMENT}
  ${ORDER_FRAGMENT}

  fragment JobFragment on JobType {
    id
    scheduledTime
    status
    isFee
    isGoAnytime
    isMock
    order {
      ...OrderFragment
    }
    inspections {
      ...InspectionFragment
    }
    reports {
      ...ReportRecordFragment
    }
  }
`;
